import backgroundVideo from "../../assets/images/backgroundProducts.mp4";
import "./style.css"
import pasha from "../../assets/images/affiliations/pasha-logo-one.jpg"
import pseb from "../../assets/images/affiliations/PSEB.png"
import cxo from "../../assets/images/affiliations/CXO.png"

const affiliations = [
  {
    id: 1,
    logo: pasha,
    title: "Pasha",
    fullForm: "(Pakistan Software Houses Association)",
    description: "is a premier body representing the software industry in Pakistan, fostering innovation and collaboration.",
  },
  {
    id: 2,
    logo: pseb,
    title: "PSEB",
    fullForm: "(Pakistan Software Export Board)",
    description:"is a government initiative to promote Pakistan's IT and software export sector.",
  },
  {
    id: 3,
    logo: cxo,
    title: "CXO Global",
    description:
      "is a platform for industry leaders, fostering business innovation and leadership excellence through strategic networking.",
  },
];

const Affiliations = () => {
  return (
    <div>
      <section id="heading" className="flex relative">
        {/* Background Video and Overlay */}
        <video
          className="absolute inset-0 w-full h-full object-cover"
          src={backgroundVideo}
          autoPlay
          loop
          muted
          style={{ opacity: "0.25" }}
        />

        {/* Main Content */}
        <div className="relative max-w-7xl mx-auto flex flex-col items-center justify-center h-screen z-10">
          <h1 className="text-5xl font-bold text-center text-white">
            <span className="gradient-headings">Our Affiliations</span>
          </h1>
          <p className="text-2xl text-white mt-6 mx-auto max-w-4xl text-center">
            ScitForte is proudly affiliated with leading organizations,
            including <span className="text-green-700">Pasha</span>, <span className="text-green-700">PSEB</span>, <span className="text-green-700">CXO Global</span>, reflecting our commitment to
            industry standards and innovation.
          </p>
        </div>
      </section>

      <main className="flex-grow bg-slate-900 py-12">
        <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {affiliations.map((affiliation) => (
            <div
              key={affiliation.id}
              className="bg-slate-800 border-t-2 border-l-2 border-r-4 border-b-4 border-black shadow-md shadow-black rounded-xl p-6 flex flex-col items-center text-center space-y-5"
            >
              <img
                src={affiliation.logo}
                alt={affiliation.title}
                className="h-40 w-auto object-contain mb-4 rounded-md"
              />
              <h3 className="text-2xl text-slate-100 font-semibold mb-2">{affiliation.title}</h3>
              <p className="text-gray-200"><span className="font-bold">{affiliation.title} {affiliation?.fullForm}</span> {affiliation.description}</p>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Affiliations;
